import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";

const Contact = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Header toggleSidebar={() => setOpen(true)} />
            <Sidebar isOpen={open} close={() => setOpen(false)} />
            {/* HERO */}
            <div className="about-hero">
                <div className="about-overlay">
                    <h1>CONTACT</h1>
                    <Breadcrumb />
                </div>
            </div>

            <div className="container contact-page">

                {/* CONTACT INFO */}
                <div className="contact-info">

                    <div className="contact-card">
                        <h3>📍 Address</h3>
                        <p>NAV JEEVAN MISSION SCHOOL,</p>
                        <p>SAPAHA ROAD, KASIA,</p>
                        <p>KUSHINAGAR</p>
                    </div>

                    <div className="contact-card">
                        <h3>📞 Phone</h3>
                        <p>+91 9198269162</p>
                    </div>

                    <div className="contact-card">
                        <h3>✉️ Email</h3>
                        <p>njms.kasia@gmail.com</p>
                    </div>

                </div>

                {/* CONTACT FORM */}
                <div className="contact-form">

                    <h2>Send Us a Message</h2>

                    <input type="text" placeholder="Your Name" />
                    <input type="email" placeholder="Your Email" />

                    <textarea placeholder="Your Message"></textarea>

                    <button>Send Message</button>

                </div>


                {/* MAP */}
                <div className="contact-map">
                    <iframe
                        title="map"
                        src="https://www.google.com/maps?q=Nav+Jeevan+Mission+School+Kasia+Kushinagar+UP&output=embed"
                        width="100%"
                        height="300"
                        style={{ border: 0 }}
                        loading="lazy"
                    ></iframe>
                </div>

                {/* LOCATION DETAILS */}
                <div className="contact-location">

                    <h2>Location Details</h2>

                    <div className="location-table-wrap">
                        <table className="location-table">
                            <tbody>

                                <tr>
                                    <td>NEAREST NATIONALISED BANK</td>
                                    <td>SYNDICATE BANK</td>
                                    <td>DISTANCE OF BANK FROM SCHOOL IN KM</td>
                                    <td>2</td>
                                </tr>

                                <tr>
                                    <td>NEAREST BUS STATION</td>
                                    <td>KASIA</td>
                                    <td>DISTANCE OF BUS TERMINAL FROM SCHOOL IN KM</td>
                                    <td>2</td>
                                </tr>

                                <tr>
                                    <td>NEAREST RAIL WAY STATION</td>
                                    <td>PADRAUNA</td>
                                    <td>DISTANCE OF RAIL WAY STATION FROM SCHOOL IN KM</td>
                                    <td>22</td>
                                </tr>

                                <tr>
                                    <td>NEAREST AIRPORT</td>
                                    <td>GORAKHPUR</td>
                                    <td>DISTANCE OF AIRPORT FROM SCHOOL IN KM</td>
                                    <td>55</td>
                                </tr>

                                <tr>
                                    <td>NEAREST HOSPITAL</td>
                                    <td>HANSRAJ HOSPITAL</td>
                                    <td>DISTANCE OF HOSPITAL FROM SCHOOL IN KM</td>
                                    <td>1</td>
                                </tr>

                                <tr>
                                    <td>NEAREST POLICE STATION</td>
                                    <td>KASIA</td>
                                    <td>DISTANCE OF POLICE STATION FROM SCHOOL IN KM</td>
                                    <td>2</td>
                                </tr>

                                <tr>
                                    <td>NEAREST METRO STATION</td>
                                    <td>No</td>
                                    <td>DISTANCE OF METRO FROM SCHOOL IN KM</td>
                                    <td>0</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                </div>

            </div>


            <Footer />
        </>
    );
};

export default Contact;